import {cloneDeep} from 'lodash'
import createModel from 'utils/model'
import {search} from 'crm/services/lost-customer'
import {info as weworkInfo, update as updateWeworkInfo} from 'crm/services/wechat-setting'
import {filterTagParams} from '../utils'

function getInitParams() {
    return {
        limit: 10,
        offset: 0,
        keyword: undefined, // 姓名/备注/手机号
        department_id: undefined, // number 部门id
        user_id: undefined, // number 员工id
        action_time_from: undefined, // 开始时间
        action_time_to: undefined, // 结束时间
        action_type: 8,
        order_by: undefined, // 排序 + -
        state: undefined, // 渠道 id
        group_id: undefined, // 分组id
        corp_tags: {}, // {op: 'IN/OR', except: true, values: [{id: id}]}
        personal_tags: {}, // {op: 'IN/OR', values: [{name: '标签名称', group_name: '分组名称'}]}
    }
}

export default createModel({
    namespace: 'crm_lostCustomerBlock',
    state: {
        params: getInitParams(),
        list: [],
        current: 1,
        total: 0,
        sortedInfo: null,
    },

    subscriptions: {},

    effects: {
        *search({payload}, {select, call, put}) {
            const {params} = yield select(({crm_lostCustomerBlock}) => crm_lostCustomerBlock)
            const query = {...params, ...payload.params}
            if (payload.page) {
                query.offset = query.limit * (payload.page - 1)
            }

            const searchQuery = cloneDeep(query)

            filterTagParams('corp_tags', searchQuery)
            filterTagParams('personal_tags', searchQuery)

            const res = yield call(search, searchQuery)

            if (res && res.data) {
                const data = res.data.map((item) => {
                    const corpTags = item.corp_tags
                    if (Array.isArray(corpTags) && corpTags.length) {
                        const groupTags = corpTags.map((tag) => {
                            const index = tag.indexOf(':')
                            const groupName = tag.substring(0, index)
                            const tagName = tag.substring(index + 1)
                            return {
                                group_name: groupName,
                                name: tagName,
                            }
                        })
                        return {
                            ...item,
                            corp_tags: groupTags,
                        }
                    }
                    return item
                })

                yield put({
                    type: 'setProperty',
                    payload: {
                        list: data,
                        params: query,
                        total: res.pagination.rows_found,
                        current: parseInt(res.pagination.offset / res.pagination.limit, 10) + 1,
                    },
                })
            }
            return res
        },
        *weworkInfo(_, {call}) {
            return yield call(weworkInfo)
        },
        *updateWeworkInfo({payload}, {call}) {
            return yield call(updateWeworkInfo, payload)
        },
    },
    reducers: {
        resetParams(state) {
            return {...state, params: getInitParams()}
        },
    },
})
